"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorldpayServerLaneAPI = void 0;
const shared_1 = require("@getgreenline/shared");
const WorldpayServerCommonAPI_1 = require("../WorldpayServerCommonAPI");
class WorldpayServerLaneAPI extends WorldpayServerCommonAPI_1.WorldpayServerCommonAPI {
    constructor(params) {
        super(params.appSpecificHeaders);
        this.createLaneAsync = ({ requestId, tenantSpecificHeaders, callbackUrl, payload, }) => __awaiter(this, void 0, void 0, function* () {
            const headers = Object.assign(Object.assign({}, this.getHeaders(requestId, tenantSpecificHeaders)), { 'tp-isasync': true });
            if (callbackUrl)
                headers['tp-callback-url'] = callbackUrl;
            try {
                const asyncRes = yield shared_1.axios.post(this.apiUrl, payload, {
                    headers,
                });
                const res = {
                    operationRetry: asyncRes.headers['operation-retry'],
                    resourceLocation: asyncRes.headers['resource-location'],
                };
                return res;
            }
            catch (error) {
                this.throwError(error);
            }
        });
        this.getLaneFromResourceLocation = ({ requestId, tenantSpecificHeaders, resourceLocation, }) => __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.getResourceFromLocation({
                    requestId,
                    tenantSpecificHeaders,
                    resourceLocation,
                });
                return res;
            }
            catch (error) {
                this.throwError(error);
            }
        });
        this.getLane = ({ requestId, tenantSpecificHeaders, laneId, }) => __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield shared_1.axios.get(`${this.apiUrl}/${laneId}`, {
                    headers: this.getHeaders(requestId, tenantSpecificHeaders),
                });
                return res.data;
            }
            catch (error) {
                this.throwError(error);
            }
        });
        this.getLanes = ({ requestId, tenantSpecificHeaders, }) => __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield shared_1.axios.get(this.apiUrl, {
                    headers: this.getHeaders(requestId, tenantSpecificHeaders),
                });
                return res.data;
            }
            catch (error) {
                this.throwError(error);
            }
        });
        this.updateLane = ({ requestId, tenantSpecificHeaders, laneId, payload, }) => __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield shared_1.axios.patch(`${this.apiUrl}/${laneId}`, payload, {
                    headers: this.getHeaders(requestId, tenantSpecificHeaders),
                });
                // Worldpay incorrectly lower-cases the first letter
                const language = (res.data.language.charAt(0).toUpperCase() +
                    res.data.language.slice(1));
                const updatedLane = Object.assign(Object.assign({}, res.data), { contactlessEmvEnabled: res.data.contactlessEmvEnabled === 'true', contactlessMsdEnabled: res.data.contactlessEmvEnabled === 'true', quickChipEnabled: res.data.contactlessEmvEnabled === 'true', language });
                return updatedLane;
            }
            catch (error) {
                this.throwError(error);
            }
        });
        this.deleteLane = ({ requestId, tenantSpecificHeaders, laneId, }) => __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield shared_1.axios.delete(`${this.apiUrl}/${laneId}`, {
                    headers: this.getHeaders(requestId, tenantSpecificHeaders),
                });
                return res.data;
            }
            catch (error) {
                this.throwError(error);
            }
        });
        this.requestActivationCode = ({ requestId, tenantSpecificHeaders, laneId, }) => __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield shared_1.axios.post(`${this.apiUrl}/${laneId}/activationCode`, {
                    headers: this.getHeaders(requestId, tenantSpecificHeaders),
                });
                return res.data;
            }
            catch (error) {
                this.throwError(error);
            }
        });
        this.getConnectionStatus = ({ requestId, tenantSpecificHeaders, laneId, }) => __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield shared_1.axios.get(`${this.apiUrl}/${laneId}/connectionstatus`, {
                    headers: this.getHeaders(requestId, tenantSpecificHeaders),
                });
                return res.data;
            }
            catch (error) {
                this.throwError(error);
            }
        });
        this.getHeaders = (requestId, tenantSpecificHeaders) => {
            return this.getCommonHeaders(requestId, tenantSpecificHeaders);
        };
        this.apiUrl = `${params.baseUrl}/v1/lanes`;
    }
}
exports.WorldpayServerLaneAPI = WorldpayServerLaneAPI;
//# sourceMappingURL=WorldpayServerLaneAPI.js.map